export default "__VITE_ASSET__865ff1d8__"